gsap.registerPlugin(ScrollTrigger,MotionPathPlugin);


class GrainMove extends  HTMLElement {
    connectedCallback() {
        this.lines = this.querySelectorAll('.line');
    
        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this,
                start: `top top+=70%`, 
                end: 'bottom bottom-=15%',  
                scrub: true,
            }
           
        });

        this.animateGrain();
    }
    hideGrain () {
        this.querySelectorAll(".grain").forEach( (grain) => {
            grain.classList.remove('active');
        })
    }
    animateGrain() {
        this.lines.forEach((line) => {
                this.tl.to(line.querySelector('.grain'), {
                    onUpdate: ()=> {
                        this.hideGrain();
                        line.querySelector('.grain').classList.add('active');
                    },
                    motionPath: {
                        path: line.querySelector('.line-path'), 
                        autoRotate: '-50deg'
                    },
                    duration: 25,
                    ease: "power1.inOut"
                });
            
        })
    }
}

customElements.define('grain-move', GrainMove);
// class GrainMove extends  HTMLElement {
//     connectedCallback() {
//         this.lines = this.querySelectorAll('.line');
//         this.tl = gsap.timeline({
//             scrollTrigger: {
//                 trigger: this,
//                 start: `top top+=70%`, 
//                 end: 'bottom bottom',  
//                 scrub: true,
//                 markers:true
//             }
           
//         });

//         this.animateGrain();
//     }

//     animateGrain() {

//         this.lines.forEach((line) => {
//             this.tl.to(line.querySelector('.grain'),{
//                 duration:25,
//                 motionPath: {
//                     path: line.querySelector('.line-path'),
//                     autoRotate: '-50deg'
//                 }
//            });
//         })
        
//     }
// }

// customElements.define('grain-move', GrainMove);

// class GrainMove extends  HTMLElement {
//     connectedCallback() {
//         this.lines = this.querySelectorAll('.line');
//         if( this.lines.length ) {
//             this.tl = gsap.timeline({
//                 scrollTrigger: {
//                     trigger: this,
//                     start: `top top+=80%`, 
//                     end: 'bottom bottom',  
//                     scrub: true
            
//                 }
               
//             });
    
//             this.animateGrain();
//         }
      
//     }

//     animateGrain() {
//         this.lines.forEach((line) => {
//             const paths = line.querySelectorAll('.line-path');

           
//             paths.forEach((path) => {
//                 const color = path.getAttribute('colr');
//                 this.tl.to(line.querySelector('.grain'), {
//                     duration: 1,
//                     onUpdate: () => {
//                         this.querySelector('.grain').setAttribute('fill', color);
//                     },
//                     motionPath: {
//                         path: path,
//                         align: path,
//                         alignOrigin: [0.5, 0.5],
//                         autoRotate: '-50deg',
                        
//                     },
//                     ease: "power1.inOut"
//                 });
//             });
//         });
//     }
// }

// customElements.define('grain-move', GrainMove);